import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import MomSysFailLotDecompositionDialog from "../dialogTypes/MomSysFailLotDecompositionDialog";
import getList from "../../lib/api/getList";

function MomSysFailLotDecompositionButton ( props ) {

    const { id, refresh, onClose, onSuccess, createButtonName, customizeErrorMsgCallback, setInitialDataCallback, modifyUrlCallback, onSelect, ...others } = props;

    const { t } = useTranslation();

    const [ open, setOpen ] = useState(false);
    const [ schema, setSchema ] = useState();
    const [ items, setItems ] = useState([]);

    useEffect(() => {

        let schema = {

            name: "MomSysFailLotManagement",
            type: "BASE TABLE",
            searchAll: false,

            columns: [

                {
                    name: "componentName",
                    type: "varchar(200)",
                    nullable: "NO",
                    default: null,
                    hideInForm: true,
                    formOrder: 10,
                    formItemType: "text",
                    grid: {
                        isReadOnly: true, 
                        type: "editor"
                    }
                },
                {
                    name: "componentCode",
                    type: "varchar(200)",
                    nullable: "NO",
                    default: null,
                    hideInForm: true,
                    formOrder: 20,
                    formItemType: "text",
                },
                {
                    name: "componentCodeVer",
                    type: "bigint(20)",
                    nullable: "NO",
                    default: null,
                    disabled: true,
                    hideInForm: true,
                    formOrder: 30,
                    formItemType: "text",
                },
                {
                    name: "consumeQty",
                    type: "bigint(20)",
                    nullable: "NO",
                    default: null,
                    disabled: true,
                    hideInForm: true,
                    formOrder: 40,
                    formItemType: "float",
                    grid: {
                        isReadOnly: true, 
                        type: "editor",
                        format: "G4"
                    },
                },
                {
                    name: "recycleQty",
                    type: "bigint(20)",
                    nullable: "NO",
                    default: null,
                    disabled: true,
                    hideInForm: true,
                    formOrder: 50,
                    formItemType: "float",
                    grid: {
                        isReadOnly: false, 
                        type: "editor",
                        format: "G4"
                    },
                    validation: {
                        msg: "error.floatRequired",
                        type: "regexp",
                        value: "^[+-]?([0-9]*[.])?[0-9]+$",
                    },
                    editor: { 
                        type: "number", 
                        props: {
                            format: 'G4',
                            min: 0
                        }
                    }
                },
                {
                    name: "price",
                    type: "bigint(20)",
                    nullable: "NO",
                    default: null,
                    disabled: true,
                    hideInForm: true,
                    required: true,
                    formOrder: 70,
                    grid: {
                        isReadOnly: false, 
                        type: "editor",
                        format: "G4"
                    },
                    validation: {
                        msg: "error.floatRequired",
                        type: "regexp",
                        value: "^[+-]?([0-9]*[.])?[0-9]+$",
                    },
                    editor: { 
                        type: "number", 
                        props: {
                            format: 'G4',
                            min: 0
                        }
                    }
                },
                {
                    name: "amount",
                    type: "bigint(20)",
                    nullable: "NO",
                    default: null,
                    disabled: true,
                    hideInForm: true,
                    required: true,
                    formOrder: 80,
                    grid: {
                        isReadOnly: false, 
                        type: "editor",
                        format: "G4"
                    },
                    validation: {
                        msg: "error.floatRequired",
                        type: "regexp",
                        value: "^[+-]?([0-9]*[.])?[0-9]+$",
                    },
                    editor: { 
                        type: "number", 
                        props: {
                            format: 'G4',
                            min: 0
                        }
                    }
                },
                {
                    name: "companyCode",
                    type: "varchar(50)",
                    nullable: "NO",
                    default: null,
                    hideInForm: false,
                    formOrder: 90,
                    formItemType: "autocomplete",
                    codeInfo: {
                        tableName: "MomSysVwCompanyWithOwn/purchase",
                        nameColumn: "companyName",
                        valueColumn: "companyCode",
                        useEmptyValue: false,
                        sortByName: true,
                    },
                    required: true,
                },
                {
                    name: "wareHouseCode",
                    type: "varchar(50)",
                    nullable: "NO",
                    default: null,
                    hideInForm: false,
                    required: true,
                    formOrder: 100,
                    formItemType: "autocomplete",
                    codeInfo: {
                        tableName: "MomSysVwInputWareHouse",
                        nameColumn: ["wareHouseCode", "wareHouseName"],
                        valueColumn: "wareHouseCode",
                        useEmptyValue: true,
                        emptyName: "term.none",
                        sortByName: true,
                    },
                },
            ]

        };

        setSchema(schema);

    }, []);

    useEffect( () => {

        (async () => {

            if(onSelect && open) {
    
                const bomList = await getList(`MomSysZvwBillOfMaterial/${onSelect[0].materialCode}/${onSelect[0].materialCodeVer}/${onSelect[0].qtyCurrent}`);

                setItems(bomList.data.map((row) => ({...row, recycleQty: 0, price: 0, amount: 0})));
    
            }
    
        })();

    }, [onSelect, open])

    const onOpen = () => {

        setOpen ( true );

    };

    const onDialogClose = () => {

        setOpen ( false );

        if ( onClose ) {

            onClose ();

        }

    };

    const onCreateSuccess = ( msg ) => {

        if ( onSuccess ) {

            onSuccess ( msg );

        }

        if(refresh) {
            refresh.refresh ();
        }

    };

    const modifyUrl = (url) => {

        return url + "/failLotDecomposition"

    }

    return (

        <>
            <CreateRecordButtonLayout id={id+"-failLotDecomposition-button"} onClick={onOpen} createButtonName ={createButtonName} {...others} />
            <MomSysFailLotDecompositionDialog
                id={id+"failLotDecomposition-dialog"}
                mode="create"
                formId={id+"failLotDecomposition-form"}
                title={ schema ? t ( `dialog.title.${schema.name}.failLotDecomposition` ) : "" }
                schema={schema}
                initialData={undefined}
                open={open}
                onClose={onDialogClose}
                onSuccess={onCreateSuccess}
                customizeErrorMsgCallback={customizeErrorMsgCallback}
                setInitialDataCallback={setInitialDataCallback}
                modifyUrlCallback={modifyUrl}
                noKeepOpen
                items={items}
                onSelect={onSelect}
                maxWidth={"lg"}
            />
        </>

    );
}

export default MomSysFailLotDecompositionButton;

